import React, { useState } from "react";
import { FaPercent } from "react-icons/fa";

export default function OrderSummaryMobile() {
    const [showInput, setShowInput] = useState(false);
  const [voucher, setVoucher] = useState("");
  return (
    <div style={{padding:"0 5px"}}>
    <div className="d-block d-md-none p-3 bg-light rounded">
      {/* Order Details */}
      <div className="mb-3">
        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted">Subtotal (2 items)</span>
          <span className="text-muted">₹ 536.98</span>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted">Delivery</span>
          <span className="text-muted">$ 0.00</span>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted">Voucher</span>
          <span className="text-muted">-</span>
        </div>
        <div className="d-flex justify-content-between fw-semibold mt-3">
          <span>Total</span>
          <span className="text-dark">₹ 536.98</span>
        </div>
      </div>

      {/* Add Voucher */}
    <div className="bg-white rounded px-3 py-2">
      
      <div className="d-flex align-items-center">
        <FaPercent className="text-warning me-2" />
        <span className="flex-grow-1 text-muted">Add Voucher</span>
        <button
          className="btn btn-sm btn-light text-dark px-3 py-1 border-0 shadow-sm"
          onClick={() => setShowInput(!showInput)}
        >
          {showInput ? "Apply" : "Add"}
        </button>
      </div>

      {/* Voucher input below (conditionally shown) */}
      {showInput && (
        <div className="mt-2">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Enter voucher"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      )}
    </div>
    </div>
    </div>
  );
}
